export default {
  // Nav
  nav: {
    bracket: 'Bracket',
    leaderboard: 'Leaderboard',
    champion: 'Champion',
    championBoard: 'Champion Board',
    admin: 'Admin',
    myPick: 'My Pick',
    signOut: 'Sign out',
    signOutConfirm: 'Sign out?',
    yes: 'Yes',
    no: 'No',
  },

  // Join / Auth
  join: {
    title: 'WC 2026 Predictor',
    subtitle: 'FIFA World Cup knockout bracket prediction challenge',
    enterCode: 'Enter invite code',
    enterCodeDesc: 'You need an invite code to join. Ask your group admin for one.',
    inviteCode: 'Invite code',
    inviteCodePlaceholder: 'Enter invite code',
    verifyCode: 'Verify Code',
    signIn: 'Sign In',
    createAccount: 'Create Account',
    displayName: 'Display name',
    displayNamePlaceholder: 'e.g. Lingxun',
    email: 'Email',
    emailOptional: '(optional — needed for password reset)',
    emailPlaceholder: 'you@example.com',
    password: 'Password',
    passwordPlaceholder: 'Min 8 characters',
    passwordSignInPlaceholder: 'Your password',
    confirmPassword: 'Confirm password',
    confirmPasswordPlaceholder: 'Re-enter password',
    forgotPassword: 'Forgot password?',
    differentCode: '← Use a different invite code',
    nameHint: '2–30 characters, must be unique',
    welcome: 'Welcome, {{name}}!',
    passwordMismatch: 'Passwords do not match',
    passwordTooShort: 'Password must be at least 8 characters',
    group: 'Group',
    invalidCode: 'Invalid or expired invite code.',
  },

  // Forgot / Reset password
  forgotPassword: {
    title: 'Reset Password',
    heading: 'Forgot your password?',
    desc: "Enter the email you signed up with and we'll send you a reset link.",
    emailLabel: 'Email address',
    send: 'Send Reset Link',
    sentTitle: 'Check your inbox',
    sentDesc: "If that email is registered, a reset link has been sent. If you don't have email set up, contact your group admin for a manual reset.",
    backToSignIn: 'Back to Sign In',
  },
  resetPassword: {
    title: 'Set New Password',
    newPassword: 'New password',
    confirmPassword: 'Confirm password',
    submit: 'Set New Password',
    successTitle: 'Password updated!',
    successDesc: 'Redirecting to sign in…',
    invalidLink: 'Invalid reset link.',
    requestNew: 'Request a new one.',
    mismatch: 'Passwords do not match',
    tooShort: 'Password must be at least 8 characters',
  },

  // Bracket
  bracket: {
    title: 'WC 2026 Predictor',
    subtitle: 'Knockout Bracket',
    preliminaryBadge: 'Preliminary matchups',
    confirmedBadge: 'Matchups confirmed',
    lockIn: 'Predictions lock in',
    nextLockIn: 'Next match locks in',
    open: 'Predictions open',
    locked: '🔒 Locked',
    scorePredictions: 'Score predictions (+3pts bonus)',
    picked: '{{count}}/{{total}} picked',
    save: 'Save Predictions',
    notAvailable: 'Bracket not yet available',
    notAvailableDesc: 'The admin will seed the bracket once the group stage concludes.',
    thirdPlace: '3rd Place',
    savedCount: 'Saved {{count}} predictions!',
    preliminary: '~ PRELIMINARY',
    pickNow: '● pick now',
    matchupsReady: '⚡ matchups ready',
    rounds: {
      R32: 'Round of 32',
      R16: 'Round of 16',
      QF: 'Quarterfinals',
      SF: 'Semifinals',
      '3RD': '3rd Place',
      FINAL: 'Final',
    },
  },

  // Leaderboard
  leaderboard: {
    title: 'Leaderboard',
    updated: 'Updated {{time}}',
    loading: 'Loading…',
    global: '🌍 Global',
    yourPosition: 'Your position',
    maxPts: '/ {{max}} max pts',
    players: 'Players',
    leaderPts: 'Leader pts',
    aiPlayers: 'AI players',
    noPicksYet: 'No predictions yet. Be the first!',
    championBoard: '🎯 Champion Board',
    submitted: 'Submitted',
    picksTitle: 'Bracket picks',
    picksLocked: 'Picks are hidden until this round locks.',
  },

  // Champion Pick
  champion: {
    title: 'Champion Pick',
    subtitle: 'Who will win the World Cup?',
    board: '🎯 Board',
    infoTitle: 'Champion Only Mode',
    infoDesc: 'Pick the tournament winner and earn <b>20 points</b> if you\'re right. You can also fill in the full bracket for more points — this is just bonus.',
    infoDescPre: 'Pick the tournament winner and earn',
    infoDescPost: 'if you\'re right. You can also fill in the full bracket for more points — this is just bonus.',
    points: 'points',
    locked: 'Picks are now locked.',
    currentPick: 'Your current pick',
    search: 'Search teams…',
    group: 'Group {{name}}',
    pickBtn: 'Pick {{flag}} {{name}}',
    selectTeam: 'Select a team',
    saved: 'Champion pick saved!',
  },

  // Champion Board
  championBoard: {
    title: 'Champion Board',
    subtitle: 'Who picked the champion?',
    myPick: 'My Pick',
    pending: 'The champion will be revealed when the Final is played.',
    worldChampion: 'World Cup Champion',
    correctOf: '{{count}} of {{total}} picker{{plural}} got it right',
    yourPick: 'Your pick',
    totalPicks: 'Total picks',
    teamsPicked: 'Teams picked',
    correct: 'Correct',
    noPicks: 'No champion picks yet. Be the first!',
    pickChampion: 'Pick your champion',
    champion: 'Champion ✓',
    picked: '{{count}} pick{{plural}}',
  },

  // Group Standings
  standings: {
    title: 'Group Stage',
    subtitle: 'Live standings · auto-refreshes every 60s',
    group: 'Group {{name}}',
    pos: '#',
    team: 'Team',
    p: 'P',
    w: 'W',
    d: 'D',
    l: 'L',
    gf: 'GF',
    ga: 'GA',
    gd: 'GD',
    pts: 'Pts',
    noData: 'Standings not available yet.',
    noDataDesc: 'They will appear once the group stage begins.',
    qualifies: 'Advances',
    thirdPlayoff: 'Best 3rd',
    fetchedAt: 'Updated {{time}}',
    nav: 'Standings',
  },

  // Misc
  common: {
    back: '← back',
    error: 'Error',
    failedToLoad: 'Failed to load',
  },

  // Feature strip
  features: {
    exactScore: 'Exact score',
    exactScoreDesc: '+3pts bonus',
    progressive: 'Progressive',
    progressiveDesc: 'R32→Final 1→16pts',
    championPick: 'Champion Pick',
    championPickDesc: 'Early pick +20pts',
  },
} as const
